<template>

  <div class="button-classic_container">
    <div v-if="!ifLink" class="button-classic" @click="$emit('click')">

      {{text}}

    </div>

    <a :href="href" v-if="ifLink" class="button-classic" @click="$emit('click')">

      {{text}}

    </a>
  </div>

</template>

<script>

export default {

  name: 'ButtonClassic',
  props: ['text', 'ifLink', 'href']

}

</script>

<style lang="sass">
*
  text-decoration: none

.button-classic

  width: 258px
  height: 57px

  border: 2px solid #D357FF
  background-color: black
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25)
  border-radius: 72px
  color: white
  text-transform: uppercase
  font-weight: 300
  font-size: 1.5em

  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  cursor: pointer

  &_final .button-classic
    width: 244px
    height: 57px

  &_vk .button-classic
    width: 57px
    height: 57px
    background-image: url(../assets/img/share.svg)
    background-size: 60%
    background-position: top 39% center

    &:hover, &:active
      background-image: url(../assets/img/share_active.svg)

  &_start .button-classic
    margin-top: 25px

  &:hover
    background-color: #D357FF
    border: 2px solid #FFFFFF
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25)
    border-radius: 72px
    color: black

  &:active
    background-color: #D357FF
    border: 1.72093px solid #B0F80C
    box-shadow: 0px 1.72093px 1.72093px rgba(0, 0, 0, 0.25)
    transform: scale(.86)

@media (max-width: 420px)
  .button-classic
    width: 64vw
    height: 14vw
    margin-top: 5vw

    &_final
      width: 60vw
      height: 15vw
      margin-top: 0

    &_vk
      width: 15vw
      height: 15vw
      font-size: 1.7em
      margin-top: 0

</style>
